var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"eaasi-loader"},[_c('div',{staticClass:"eaasi-loader-rings"}),_c('img',{staticClass:"eaasi-logo",attrs:{"src":require("@/assets/header-logo.png"),"alt":"eaasi loader"}})])}]

export { render, staticRenderFns }